import { useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Icon } from '../components/Icon';
import { StoreFooter } from './StoreFooter';

export function PaymentResultPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const status = params.get('status');
  const orderId = params.get('orderId');
  const trackingCode = params.get('trackingCode');
  const error = params.get('error');

  const isSuccess = status === 'success';

  return (
    <div className="storefront-page customer-payment-result" style={{ padding: "var(--ds-space-10) var(--ds-space-5)", minHeight: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div className="card customer-payment-card" style={{ maxWidth: 500, width: '100%', padding: "var(--ds-space-10) var(--ds-space-5)", textAlign: 'center', marginTop: "var(--ds-space-5)" }}>
        <div style={{
          width: 80, height: 80, borderRadius: '50%',
          background: isSuccess ? 'var(--success-bg)' : 'var(--warn-bg)',
          color: isSuccess ? 'var(--success)' : 'var(--warn)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: "0 auto var(--ds-space-5)"
        }}>
          <div style={{ width: 40, height: 40, display: 'flex' }}>
            <Icon name={isSuccess ? 'check' : 'warn'} />
          </div>
        </div>
        <h2 style={{ marginBottom: 10, fontSize: "var(--ds-text-title)" }}>
          {isSuccess ? 'پرداخت شما با موفقیت انجام شد' : 'پرداخت ناموفق بود'}
        </h2>
        
        {isSuccess ? (
          <p style={{ color: 'var(--muted)', lineHeight: 1.6, marginBottom: 30 }}>
            سفارش شما با موفقیت ثبت و پرداخت شد. در حال پردازش جهت ارسال می‌باشد.
          </p>
        ) : (
          <p style={{ color: 'var(--muted)', lineHeight: 1.6, marginBottom: 30 }}>
            عملیات پرداخت با خطا مواجه شد و یا توسط شما لغو گردید. در صورتی که مبلغی از حساب شما کسر شده باشد، تا ۷۲ ساعت آینده از طرف بانک بازگشت داده خواهد شد.
          </p>
        )}

        <div style={{ background: 'var(--bg)', padding: 15, borderRadius: 12, marginBottom: 30, textAlign: 'right' }}>
          {orderId && (
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
              <span className="muted">شماره سفارش:</span>
              <b>{orderId}</b>
            </div>
          )}
          {trackingCode && (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span className="muted">کد پیگیری درگاه:</span>
              <b className="ltr-inline">{trackingCode}</b>
            </div>
          )}
          {error && (
            <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--warn)' }}>
              <span className="muted">کد خطا:</span>
              <b className="ltr-inline">{error}</b>
            </div>
          )}
        </div>

        <div className="customer-payment-actions" style={{ display: 'flex', gap: 15, justifyContent: 'center' }}>
          <Link to="/account" className="btn primary">پیگیری سفارشات</Link>
          <Link to="/" className="btn outline">بازگشت به فروشگاه</Link>
        </div>
      </div>
    </div>
  );
}
